import type { CSSProperties } from "react";

/**
 * Habillage de cette visite. Volontairement minuscule : le moteur fournit des
 * styles sobres et neutres, et tout ce qui relève de l'identité du lieu vivra
 * dans le module `tenant` — pas ici, en dur.
 *
 * Les deux familles sont déclarées dans `typography.css` et lues ici par
 * variables CSS : une seule source pour le choix des caractères.
 */

/** Interface : menus, panneaux, boutons, messages. */
export const POLICE_UI = "var(--police-ui)";

/** Annonce du nom de scène, à l'arrivée dans un lieu. */
export const POLICE_TITRE = "var(--police-titre)";

export const toggleStyle: CSSProperties = {
  position: "absolute",
  bottom: 12,
  right: 12,
  padding: "5px 9px",
  borderRadius: 6,
  border: "1px solid #3a3a3a",
  background: "rgba(17,17,17,0.72)",
  color: "#ccc",
  fontSize: 13,
  textDecoration: "none",
  pointerEvents: "auto",
};

/** Écrans de chargement et d'erreur : plein cadre, centré, sobre. */
export const centeredStyle: CSSProperties = {
  position: "absolute",
  inset: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 10,
  padding: 24,
  background: "#111",
  color: "#ccc",
  fontFamily: POLICE_UI,
  fontSize: 14,
  lineHeight: 1.5,
  textAlign: "center",
};

/**
 * Repère de provenance en mode `?live`. Sans lui, rien ne distingue à l'écran
 * une visite servie par le disque d'une visite servie par R2 — et c'est
 * précisément ce qu'on cherche à vérifier.
 */
export const liveBadgeStyle: CSSProperties = {
  position: "absolute",
  top: 12,
  left: "50%",
  transform: "translateX(-50%)",
  padding: "3px 10px",
  borderRadius: 999,
  border: "1px solid #7cf",
  background: "rgba(0,0,0,0.55)",
  color: "#7cf",
  fontSize: 11,
  letterSpacing: 0.4,
  textTransform: "uppercase",
  pointerEvents: "auto",
};

export const issuesStyle: CSSProperties = {
  position: "absolute",
  bottom: 12,
  left: 220,
  margin: 0,
  color: "#f88",
  fontSize: 12,
  whiteSpace: "pre-wrap",
};
